import React from 'react';
import TransientThoughtBubble from './TransientThoughtBubble';
import TransientThoughtCloud from './TransientThoughtCloud';
import TransientThoughtSpeechBubble from './TransientThoughtSpeechBubble';

/**
 * Renders a single live (animating) transient thought — either the speech-bubble
 * or the thought-cloud variant. Wraps the shared prop wiring so the master and
 * slave slots don't duplicate it.
 */
const TransientThoughtLiveBubble = ({
  isBubbleStyle, config, disableBubble, initiateAnimation, variants,
  colors, baseFillColor, fontFamily, fontSize, containerSize, showUsername
}) => {
  if (!config) return null;

  const shared = {
    config,
    disableBubble,
    initiateAnimation,
    variants,
    fontFamily,
    fontSize,
    textColor: colors?.ttmultipleColors ? '#000000' : colors?.ttTextColor1,
    fillColor: colors?.ttmultipleColors ? config?.fillColor : baseFillColor
  };

  if (isBubbleStyle) {
    return (
      <TransientThoughtSpeechBubble
        {...shared}
        containerSize={containerSize}
        transientThoughtShowUsername={showUsername}
      />
    );
  }

  return (
    <TransientThoughtCloud
      {...shared}
      containerSize={containerSize}
      transientThoughtShowUsername={showUsername}
    />
  );
};

export default TransientThoughtLiveBubble;
